import PropTypes from 'prop-types'
import intlPropTypes from '../../types/intlPropTypes'

const propTypes = {
  classes: PropTypes.shape({
    callToAction: PropTypes.string,
    card: PropTypes.string,
    cardContent: PropTypes.string,
    cardMedia: PropTypes.string,
    firstCardMedia: PropTypes.string,
    h3: PropTypes.string,
    paragraph: PropTypes.string,
    root: PropTypes.string,
    secondCard: PropTypes.string,
    secondCardMedia: PropTypes.string
  }),
  className: PropTypes.string,
  intl: PropTypes.shape(intlPropTypes),
  ctaOnClick: PropTypes.func,
  isEloThemeActive: PropTypes.bool
}

export default propTypes
